// extracted by mini-css-extract-plugin
export default {"headerLogo":"HeaderLogo_headerLogo__Zc9Zw","svgburger":"HeaderLogo_svgburger__9mM3l","svglogo":"HeaderLogo_svglogo__8MiBk"};